import { createFileRoute } from "@tanstack/react-router"

import { VehicleForm } from "@/trips/components/mileage/vehicle-form"

export const Route = createFileRoute("/_app-shell/vehicles/new")({
  head: () => ({ meta: [{ title: "Add vehicle - Kestly" }] }),
  component: VehicleForm,
})
